module.exports = __webpack_public_path__ + "static/media/icon-message-circle-fill.9da9bce1.svg";